import { ChangeEvent, useRef, useState } from 'react'
import DateTimeRangeFilter, { DateFilterObject } from '../../../common/filter/DateTimeRangeFilter'
import { SelectData } from '../../../common/filter/models'
import CashBoxFilter, {
  selectType as cashBoxSelectType,
} from '../../../common/filter/CashBoxFilter'
import MerchantFilter, {
  selectType as merchantSelectType,
} from '../../../common/filter/MerchantFilter'
import PaymentTicketStatusesFilter, {
  selectType as statusesSelectType,
} from '../../../common/filter/PaymentTicketStatusesFilter'
import { selectType as processTypeSelectType } from '../../../common/filter/PaymentTicketProcessTypeFilter'
import { IsGranted } from '../../auth/PrivateRoute'
import { ROLE, useAuth } from '../../auth'
import { isAdapterScopeRequired } from '../../../common/filter/adapterIdSearch'
import PaymentAdapterFilter, {
  selectType as paymentAdapterSelectType,
} from '../../../common/filter/PaymentAdapterFilter'
import PaymentMethodsFilter, {
  selectType as paymentMethodType,
} from '../../../common/filter/PaymentMethodsFilter'
import TicketTypeFilter, {
  selectType as ticketTypeFilterType,
} from '../../../common/filter/TicketTypeFilter'

const FinishedTicketFilter = ({
  initialFilter,
  updateFilters,
  callback,
}: {
  initialFilter: any
  updateFilters: (key: any) => void
  callback: (param1?: boolean, param2?: boolean, exportCsv?: boolean) => void
}) => {
  const { currentUser } = useAuth()
  const [filterBy, setFilterBy] = useState<string>('byCreatedDate')
  const searchIdRef = useRef<HTMLInputElement>(null)
  const searchMerchantRef = useRef<HTMLInputElement>(null)

  const updateTime = (filterData: DateFilterObject) => {
    updateFilters({
      ...initialFilter,
      dateStart: filterData.dateStart,
      dateEnd: filterData.dateEnd,
    })
  }

  const onFilterByChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { dateStart, dateEnd, ...rest } = initialFilter
    setFilterBy(e.target.value)

    if (e.target.value === 'byCreatedDate') {
      updateFilters({
        ...rest,
        dateStart,
        dateEnd,
        byCompletionDate: false,
      })
    } else {
      updateFilters({
        ...rest,
        dateStart,
        dateEnd,
        byCompletionDate: true,
      })
    }
  }

  const onChangeSelect = (selectData: SelectData) => {
    if (searchIdRef.current) {
      searchIdRef.current.value = ''
    }

    if (searchMerchantRef.current) {
      searchMerchantRef.current.value = ''
    }

    const filterObject = { ...initialFilter }

    switch (selectData.type) {
      case cashBoxSelectType:
        if (!selectData.value.length) {
          delete filterObject.cashBoxId
        } else {
          filterObject.cashBoxId = selectData.value
        }

        break
      case merchantSelectType:
        if (!selectData.value.length) {
          delete filterObject.merchantTokenList
        } else {
          filterObject.merchantTokenList = selectData.value
        }

        break
      case statusesSelectType:
        filterObject.ticketStatus = selectData.value

        break
      case processTypeSelectType:
        if (!selectData.value.length) {
          delete filterObject.ticketProcessType
        } else {
          filterObject.ticketProcessType = selectData.value
        }

        break

      case ticketTypeFilterType:
        if (!selectData.value.length) {
          delete filterObject.source
        } else {
          filterObject.source = selectData.value
        }

        break

      case paymentAdapterSelectType:
        if (!selectData.value.length) {
          delete filterObject.paymentAdapter
        } else {
          filterObject.paymentAdapter = selectData.value
        }

        break

      case paymentMethodType:
        if (!selectData.value.length) {
          delete filterObject.paymentMethod
        } else {
          filterObject.paymentMethod = selectData.value
        }

        break
    }

    updateFilters(filterObject)
  }

  const onSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query: any = {}

    if (e.target.name === 'search') {
      query.search = e.target.value
      updateFilters((prev: any) => ({ ...prev, ...query }))
    }
  }

  return (
    <div className='row'>
      <div className='col-lg-8'>
        <div className='row mb-7'>
          <div className='col'>
            <div className='form-check form-check-custom form-check-solid'>
              <input
                id='by-created-date-radio'
                className='form-check-input'
                type='radio'
                value='byCreatedDate'
                name='report-sort-type-radio'
                onChange={onFilterByChange}
                checked={filterBy === 'byCreatedDate'}
              />
              <label className='form-check-label' htmlFor='by-created-date-radio'>
                По дате создания
              </label>
            </div>
          </div>
          <div className='col'>
            <div className='form-check form-check-custom form-check-solid'>
              <input
                id='by-completion-date-radio'
                className='form-check-input'
                type='radio'
                value='byCompletionDate'
                name='report-sort-type-radio'
                onChange={onFilterByChange}
                checked={filterBy === 'byCompletionDate'}
              />
              <label className='form-check-label' htmlFor='by-completion-date-radio'>
                По дате закрытия
              </label>
            </div>
          </div>
        </div>
        <DateTimeRangeFilter filter={initialFilter} updateTime={updateTime} />
      </div>
      <div className='d-flex flex-column col-lg-4 gap-4 mt-4 mt-lg-0 '>
        <button className='btn btn-success ' onClick={() => callback()}>
          Фильтровать
        </button>

        <button
          className='btn btn-primary'
          onClick={() => {
            setFilterBy('byCreatedDate')
            if (searchIdRef.current) {
              searchIdRef.current.value = ''
            }

            if (searchMerchantRef.current) {
              searchMerchantRef.current.value = ''
            }

            callback(true, true)
          }}
        >
          Сбросить фильтр
        </button>

        {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER], currentUser) ? (
          <button
            className='btn btn-primary'
            onClick={() => {
              callback(initialFilter, false, true)
            }}
          >
            Экспортировать
          </button>
        ) : null}
      </div>

      <div className='col-lg-4 mt-8'>
        <div className='position-relative  me-md-2'>
          <div className='svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 start-0 translate-middle ms-5'>
            <i className='fa fa-search'></i>
          </div>
          <input
            ref={searchMerchantRef}
            type='text'
            name='search'
            className='form-control form-control-solid ps-10 pt-3 pb-2'
            onChange={onSearchChange}
            placeholder='Поиск по тикетам'
          />
        </div>
      </div>
      {isAdapterScopeRequired(currentUser) && (
        <div className='col-lg-4 mt-8'>
          <PaymentAdapterFilter
            changeSelect={onChangeSelect}
            value={initialFilter.paymentAdapter}
            isMultiple
            enabledOnly={false}
          />
          <div className='text-muted fs-7 mt-1'>
            Поиск по ID адаптера действует только внутри выбранного адаптера
          </div>
        </div>
      )}
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) ? (
        <div className='col-lg-4 mt-8'>
          <div className='row'>
            <div>
              <CashBoxFilter changeSelect={onChangeSelect} value={initialFilter.cashBoxId} />
            </div>
          </div>
        </div>
      ) : null}
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) ? (
        <div className='col-lg-4 mt-8'>
          <MerchantFilter
            changeSelect={onChangeSelect}
            value={initialFilter.merchantTokenList}
            isMultiple
          />
        </div>
      ) : null}
      {IsGranted(
        [
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_CASHIER,
          ROLE.ROLE_SENIOR_CASHIER,
          ROLE.ROLE_OPERATOR,
          ROLE.ROLE_SENIOR_OPERATOR,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ],
        currentUser
      ) ? (
        <div className='col-lg-4 mt-10'>
          <PaymentMethodsFilter value={initialFilter.paymentMethod} changeSelect={onChangeSelect} />
        </div>
      ) : null}
      {IsGranted(
        [
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_CASHIER,
          ROLE.ROLE_SENIOR_CASHIER,
          ROLE.ROLE_OPERATOR,
          ROLE.ROLE_SENIOR_OPERATOR,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ],
        currentUser
      ) ? (
        <div className='col-lg-4 mt-10'>
          <TicketTypeFilter changeSelect={onChangeSelect} value={initialFilter.source} />
        </div>
      ) : null}
      <div className='col-lg-4 mt-10'>
        <PaymentTicketStatusesFilter
          changeSelect={onChangeSelect}
          isMultiple={true}
          value={initialFilter.ticketStatus}
        />
      </div>
    </div>
  )
}

export default FinishedTicketFilter
